import React, { useEffect, useState } from "react";
import { Table, Input, Button, message } from "antd";
import { useSelector } from "react-redux";
import { fetchTestRequirement } from "./FetchTestRequirement";
import { EditOutlined } from "@ant-design/icons";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { create_test_requirement, update_test_requirement } from "../../endpoints/API";

const TestRequirements = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [inputValue, setInputValue] = useState("");
  const [editingId, setEditingId] = useState(null); // State to track the editing row
  const [TestRequirements, setTestRequirements] = useState([]); // State to store test requirements
  const isUser = useSelector((state) => state.user.user);

  useEffect(() => {
    const getTestRequirements = async () => {
      try {
        await fetchTestRequirement(setTestRequirements, baseUrl, prodTestUrl);
      } catch (error) {
        message.error(error?.response?.data?.error||"Failed to fetch test requirements.");
      }
    };

    getTestRequirements();
  }, []);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleCreateOrUpdate = async () => {
    if (inputValue?.trim()) {
      const payload = {
        name: inputValue,
        created_by: isUser.user_id,
      };

      if (editingId) {
        // Update existing test requirement
        try {
          const response = await update_test_requirement(editingId, payload);

          if (response.statusText == "OK") {
            const updatedData = response?.data;
            setTestRequirements((prev) =>
              prev.map((item) =>
                item.id === editingId ? { ...item, ...updatedData.data } : item
              )
            );
            message.success("Test requirement updated successfully!");
            setInputValue("");
            setEditingId(null);
          } else {
            message.error("Failed to update the test requirement.");
          }
        } catch (error) {
          message.error(
            error?.response?.data?.error||"An error occurred while updating the test requirement."
          );
        }
      } else {
        // Create new test requirement
        try {
          const response = await create_test_requirement(payload);

          if (response.statusText=="OK") {
            const result = response?.data;
            setTestRequirements((prevTestRequirement) => [
              ...prevTestRequirement,
              result.data,
            ]);

            setInputValue("");
            message.success("Test requirement created successfully!");
          } else {
            message.error("Test requirement already exists.");
          }
        } catch (error) {
          message.error(
            error?.response?.data?.error||"An error occurred while creating the test requirement."
          );
        }
      }
    } else {
      message.warning("Please enter a valid test requirement.");
    }
  };

  const handleEdit = (record) => {
    setInputValue(record.name);
    setEditingId(record.id);
  };

  const columns = [
    {
      title: "Test Requirements",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      {/* Input and Create/Update Button */}
      <div style={{ display: "flex", marginBottom: 20 }}>
        <Input
          placeholder="Enter test requirement"
          value={inputValue}
          onChange={handleInputChange}
          style={{ marginRight: 10 }}
        />
        <Button type="primary" onClick={handleCreateOrUpdate}>
          {editingId ? "Update" : "Create"}
        </Button>
      </div>

      {/* Table to show test requirements */}
      <Table
        columns={columns}
        dataSource={TestRequirements.map((item) => ({
          ...item,
          key: item.id,
        }))}
        pagination={false}
      />
    </div>
  );
};

export default TestRequirements;
